import axiosInstance from "../instance/axiosInstance";

class ContactApi {

	static async neighbourhoods() {
		try {
			const response = await axiosInstance.get("/neighbourhoods/1");
			if (response) {
				return response.data;
			}
		} catch (error) {
			return error;
		}
	}
	static async floors() {
		try {
			const response = await axiosInstance.get("/floors");
			if (response) {
				return response.data;
			}
		} catch (error) {
			return error;
		}
	}
	static async acType() {
		try {
			const response = await axiosInstance.get("/ac_types");
			if (response) {
				return response.data;
			}
		} catch (error) {
			return error;
		}
	}
	static async kitchenTypes() {
		try {
			const response = await axiosInstance.get("/kitchen_types");
			if (response) {
				return response.data;
			}
		} catch (error) {
			return error;
		}
	}
	
	static async submitForm(data, language = "en") {
		try {
			const response = await axiosInstance.post('/save/quote_request', data, {
				// headers: { 'Content-Type': 'multipart/form-data' },
				headers: { 
					'Content-Type': 'multipart/form-data',
					'language': language // Send language in headers
				},
				
			});
			return response.data;
		} catch (error) {
			return error;
		}
	}
	

}

export default ContactApi;
